import {
  PanelDirection,
  PanelStyle,
  PanelWidthVariant,
  StyledPanelContent,
  StyledPanelDivider,
  StyledWrapper,
} from './Panel.style';

export interface PanelProps {
  variant?: PanelStyle;
  direction?: PanelDirection;
  widthVariant?: PanelWidthVariant;
  children: React.ReactNode;
}

export const Panel = ({
  variant = 'float',
  direction = 'row',
  widthVariant = 'default',
  children,
}: PanelProps) => (
  <StyledWrapper direction={direction} variant={variant} widthVariant={widthVariant}>
    {children}
  </StyledWrapper>
);

Panel.Content = StyledPanelContent;
Panel.Divider = StyledPanelDivider;
